export const GET_ORGANISATION_DETAILS = 'GET_ORGANISATION_DETAILS'
export const GET_ORGANISATION_DETAILS_SUCCESS = 'GET_ORGANISATION_DETAILS_SUCCESS'
export const GET_ORGANISATION_DETAILS_FAIL = 'GET_ORGANISATION_DETAILS_FAIL'

export const defaultOrganisationState = {
  organisationDetails: null,
  loading: false,
  error: false,
  errorMessage: null
}

export default (state = defaultOrganisationState, action) => {
  switch (action.type) {
    case GET_ORGANISATION_DETAILS:
      return {
        ...state,
        loading: true,
        error: false
      }
    case GET_ORGANISATION_DETAILS_SUCCESS:
      if (action.payload.data.success) {
        return {
          ...state,
          organisationDetails: action.payload.data.data,
          loading: false,
          error: false,
          errorMessage: null
        }
      }
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.payload.data.errorMessage
      }
    case GET_ORGANISATION_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.payload.error || 'Failed to fetch organisation details'
      }
    default:
      return state
  }
}
